<template>
  <div>
    <div class="page-bg">
      <div class="logo">
        <img src="../assets/logo.png" alt="" />
      </div>

      <div class="login-page">
        <div class="login-form">
          <div class="title-row fcc">
            <img src="../assets/login-title.png" alt="" />
          </div>
          <div class="input-row" @click="show3 = true">
            <div class="label">
              角色：
            </div>
            <div class="input">
              <input type="text" :value="roleName" placeholder="请选择角色" maxlength="10" readonly />
            </div>
          </div>
          <div class="input-row">
            <div class="label">
              姓名：
            </div>
            <div class="input">
              <input type="text" v-model="username" placeholder="请输入姓名" maxlength="12"/>
            </div>
          </div>
          <!-- <div class="input-row" v-if="apartmentShow" @click="show = true">
            <div class="label">
              单位：
            </div>
            <div class="input">
              <input type="text" :value="apartment" placeholder="请选择单位名称" maxlength="30" readonly />
            </div>
          </div> -->
          <div class="input-row" v-if="classNameShow" @click="show2 = true">
            <div class="label">
              班级：
            </div>
            <div class="input">
              <input type="text" :value="className" placeholder="请选择班级" maxlength="10" readonly />
            </div>
          </div>
		  
		
		  
		  <!-- <van-field v-model="username" label="姓名" placeholder="请输入用户名"></van-field> -->
		  
		  
          <div class="btn-tologin fcc" @click="login">
            查看任务
          </div>
        </div>
      </div>

    </div>

    <!-- <van-popup v-model="show" position="bottom">
      <van-picker title="选择单位" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="show = false" />
    </van-popup> -->
    <van-popup v-model="show2" position="bottom">
      <van-picker title="选择班级" show-toolbar :columns="columns2" @confirm="onConfirm2" @cancel="show2 = false" />
    </van-popup>
    <van-popup v-model="show3" position="bottom">
      <van-picker title="选择角色" show-toolbar :columns="columns3" @confirm="onConfirm3" @cancel="show3 = false" />
    </van-popup>


  </div>
</template>

<script>


import { login } from "@/api/api";

export default {

  data() {
    return {
      apartment: '',
      className: '',
      username: '',
      roleName: '',
      classNameShow: true,
      apartmentShow: true,
      show: false,
      columns: ['总承包公司', '福州分公司', '江西分公司', '广东分公司', '浙江分公司', '工业建筑事业部', '海西经理部', '港航工程事业部', 'EPC事业部', '创新发展事业部','资产运营事业部'],
      show2: false,
      show3: false,
      columns2: ['1组', '2组', '3组', '4组', '5组'],
      columns3: ['学员', '工作人员', '讲师', '公司领导'],
    };
  },
  async mounted() {

  },
  methods: {
    onConfirm(value, index) {
      this.apartment = value;
      this.show = false
    },
    onConfirm2(value, index) {
      this.className = value
      this.show2 = false
    },
    onConfirm3(value, index) {
      this.roleName = value
      if (this.roleName == "学员") {
        this.classNameShow = true
        this.apartmentShow = true
      } else {
        this.classNameShow = false
        this.apartmentShow = false
      }
      this.show3 = false
    },

    login() {
      let apartment = this.apartment
      let className = this.className
      let username = this.username
      let roleName = this.roleName

      let data = {
        apartment: apartment,
        className: className,
        username: username,
        roleName: roleName
      }
      // let data = {
      //   apartment: apartment,
      //   className: className,
      //   username: username,
      //   roleName: roleName
      // }
      if (this.roleName == "学员") {
        this.apartment = '2026届新员工'
        data.apartment = '2026届新员工'
      //   if (!this.className) {
      //     this.$toast("请选择班级名称")
      //     return;
      //   }
      // }
      // if (!this.username) {
      //   this.$toast("请填写用户名称")
      //   return;
      // }
      // if (!this.roleName) {
      //   this.$toast("请填选择角色")
      //   return;
      }

      //登录
      login(data).then(res => {
        if (res.status != 200) {
          this.$toast(res.msg)
          return
        } else {
          window.localStorage.setItem('cscec2026UserId', res.data.userInfo.id)
          this.$router.push({ path: '/task-guide' })
        }
      })
    },

  },
};
</script>
<style scoped lang="less">
	
	
	input{
		-webkit-touch-callout:default !important;
		-webkit-user-select:auto !important;
		user-select:auto !important;
	}
</style>
